import { getRequestParams } from "../../pages_android/custom_views/insta_custom_views/utils_android/CookieHelper"
import fetchWithTimeout, { getHttpParams, getRequestUrl } from "../../pages_android/custom_views/insta_custom_views/utils_android/UrlHelperAndroid"
import { log } from "./ApiUtils"

// Ежедневный розыгрыш (на сервере — lottery.js). Ответ отдаётся как есть: у «Участвовать» отказ
// (мало заданий, приём закрыт) — тоже ответ, с текстом для исполнителя.
export class LotteryApi {
    static request(name, onSuccess, onError) {
        fetchWithTimeout(getRequestUrl() + "lottery/" + name, getHttpParams(getRequestParams())).then((response) => response.json())
        .then((responseData) => {
            log("lottery/" + name + " response = ", responseData)
            onSuccess(responseData || {})
        })
        .catch((e) => {
            log("lottery/" + name + " error = ", e)
            if (onError) onError({ response: -1 })
        })
    }
    // { enabled, now, prize, min_tasks, hour, minute, today: { phase, draw_at, participants, me, show }, next_draw_at, history }
    static state(onSuccess, onError) {
        LotteryApi.request("state", onSuccess, onError)
    }
    static join(onSuccess, onError) {
        LotteryApi.request("join", onSuccess, onError)
    }
    // сообщение победителя всем (до 40 символов, сервер проверяет мат и ссылки); пустое — убрать
    static message(text, onSuccess, onError) {
        const params = getRequestParams()
        params.text = text
        fetchWithTimeout(getRequestUrl() + "lottery/message", getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            log("lottery/message response = ", responseData)
            onSuccess(responseData || {})
        })
        .catch((e) => {
            log("lottery/message error = ", e)
            if (onError) onError({ response: -1 })
        })
    }
}
